import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { PreviewPage } from '@/app/(client)/questionnaires/-components/PreviewPage';
import { builderDetailQueryOptions } from '@/app/(client)/questionnaires/-hooks/useBuilderDetailQuery';
import { queryClient } from '@/lib/utils/queryClient';

/**
 * The Retraced-admin preview of a shared template: the customer `PreviewPage`
 * in template mode, reading through the management route. The customer
 * preview route sits behind the company guard, which sends a Retraced admin
 * to the company picker instead of the page. Exit returns to the admin builder.
 */
export const Route = createFileRoute(
  '/management/supplier-questionnaire-templates/(pages)/$id/preview/',
)({
  // A prefetch; its rejection is swallowed so the preview's own loading and
  // error handling stay in charge.
  loader: ({ params }) =>
    queryClient
      .ensureQueryData(
        builderDetailQueryOptions('template', params.id, 'admin'),
      )
      .catch(() => undefined),
  component: AdminTemplatePreviewRoute,
});

function AdminTemplatePreviewRoute() {
  const { id } = Route.useParams();
  const navigate = useNavigate();

  return (
    <PreviewPage
      mode='template'
      id={id}
      scope='admin'
      onExit={() =>
        void navigate({
          to: '/management/supplier-questionnaire-templates/$id/edit',
          params: { id },
        })
      }
    />
  );
}
